import { create } from "zustand";
import createAuthSlice, { AuthSlice } from "./AuthStore/createAuthSlice";

export type AuthStoreType = AuthSlice;

const useAuthStore = create<AuthStoreType>((...actions) => ({
    ...createAuthSlice(...actions),
}));

export default useAuthStore;
